import S360Link from "root/s360components/S360Link";
import React, {Fragment} from "react";
import {useAdminUsersDashboardContext} from "root/s360components/AdminUsersDashboardContext";

const DashboardSchoolAdminLinks = () =>
{

    /*
    const [data, setData] = useState({isLoading: true, data: []})

    useEffect(() =>
    {
        getData();
    }, [])

    const getData = () =>
    {
        getSALinksForSchool(school_id, (response) =>
        {
            const data = getDataFromResponse(response);

            setData({isLoading: false, data: data})
        })
    }

     */

    const {isLoading, data} = useAdminUsersDashboardContext();


    return (
        <Fragment>
            <S360Link url={data.sa_admin.si_all_schools_link} target= '_blank' title='Local Authority' icon="glyphicon glyphicon-folder-open"/>
            <S360Link url={data.sa_admin.p_link} target= '_blank' title='My Partnership' icon="glyphicon glyphicon-folder-open"/>
        </Fragment>
    )
}

export default DashboardSchoolAdminLinks;